__turbopack_context__.v({
  "modalBody": "_1RkIrG_modalBody",
  "modalContent": "_1RkIrG_modalContent",
  "modalFooter": "_1RkIrG_modalFooter",
  "modalHeader": "_1RkIrG_modalHeader",
});
